import React, { useEffect, useState } from 'react';
import { RedocStandalone } from 'redoc';
import AppBar from "./components/AppBar";
import { Redirect, Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import yaml from 'js-yaml';
import axios from 'axios';
import { getApiBaseUrl } from './utils/env';

function App() {
    const [spec, setSpec] = useState(null);

    useEffect(() => {
        const loadYaml = async () => {
            try {
                const response = await axios.get('/apiDocument.yaml'); // Public path
                const parsed = yaml.load(response.data);

                // Inject dynamic server
                parsed.servers = [
                    {
                        url: getApiBaseUrl(),
                    },
                ];

                setSpec(parsed);
            } catch (err) {
                console.error("Error loading YAML:", err);
            }
        };

        loadYaml();
    }, []);

    return (
        <Router>
            <AppBar />
            <Switch>
                <Route path="/apiDocumentation">
                    {spec ? (
                        <RedocStandalone
                            spec={spec}
                            options={{
                                nativeScrollbars: true,
                                theme: { colors: { primary: { main: '#0071F2' } } }
                            }}
                        />
                    ) : (
                        <div>Loading API documentation...</div>
                    )}
                </Route>
                <Redirect path='/' to='/apiDocumentation' />
            </Switch>
        </Router>
    );
}

export default App;
